import {AuthTypesEnum} from "@/lib/enums/AuthTypesEnum";
import {MainCtaBtn} from "@/app/components/common/main-cta-btn/MainCtaBtn";
import React from "react";
import {CtaBtn} from "@/app/components/common/cta-btn/CtaBtn";
import {useTranslations} from "next-intl";
import {useSearchParams} from "next/navigation";
import {useOpenDialog} from "@/lib/dialog-orchestrator/react";
import {DialogsEnum} from "@/lib/enums/DialogsEnum";
import {AuthQueryValue, authQueryHref} from "@/lib/utils/contants/authQuery";

export default function UnauthorizedHeader() {
    const t = useTranslations();
    const openDialog = useOpenDialog();
    // Preserve the landing query (affiliate/UTM attribution) in the CTA hrefs so
    // a pre-hydration navigation doesn't strip params captured on the next load.
    const currentSearch = useSearchParams().toString();

    // The CTAs render as real links (see `authQueryHref`) so a tap before
    // hydration still navigates to `?auth=…` and `AuthUrlOpener` opens the
    // dialog on load. Once hydrated, we intercept and open it directly — but
    // let modified clicks (open-in-new-tab) fall through to the native href.
    const openAuth =
        (tab: AuthTypesEnum) => (e: React.MouseEvent<HTMLAnchorElement>) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            e.preventDefault();
            openDialog(DialogsEnum.AUTH, {props: {tab}});
        };

    return (
        <div className={'flex items-center flex-nowrap'}>
            <CtaBtn className={'md:h-[51px] md:px-[24px] md:text-[16px]'}
                    href={authQueryHref(AuthQueryValue.LOGIN, currentSearch)}
                    onClick={openAuth(AuthTypesEnum.LOGIN)}>
                {t('UnauthorizedHeader.login')}
            </CtaBtn>
            <MainCtaBtn className={'ml-[6px] md:ml-[8px] md:h-[51px] md:w-[125px] md:text-[16px]'}
                        href={authQueryHref(AuthQueryValue.REGISTER, currentSearch)}
                        onClick={openAuth(AuthTypesEnum.REGISTER)}>
                {t('UnauthorizedHeader.register')}
            </MainCtaBtn>
        </div>
    )
}
